export default {
    driver_performance_events_info_caseId: "CaseID",
    driver_performance_events_info_status: "Status",
    driver_performance_events_info_next_step: "Next Step",
    driver_performance_events_info_created: "Created",
    driver_performance_events_info_driver: "Driver",
    driver_performance_events_info_coach: "Coach",
    driver_performance_events_info_evaluation: "Evaluation",
    driver_performance_events_info_complete: "Complete",
    driver_performance_events_info_no_case_info: "No Case information available.",
    driver_performance_events_info_unassigned: "Unassigned",
    driver_performance_events_change_coach: "Change Coach",
};